/**
 * @generated SignedSource<<323c616925955ff825727acc317e0e87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type linkUnit4ProjectModal_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly id: string;
    readonly unit4Enabled: boolean | null;
  } | null;
  readonly " $fragmentType": "linkUnit4ProjectModal_viewer";
};
export type linkUnit4ProjectModal_viewer$key = {
  readonly " $data"?: linkUnit4ProjectModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"linkUnit4ProjectModal_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "linkUnit4ProjectModal_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit4Enabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "07efce5f746ba72b96f093bb88267814";

export default node;
